define('features/overlayGameLauncher/adventureTwo/summary/SummaryModel',[],function () {

    return function AdventureTwoSummaryModel (summaryObservableData) {
        var self = this;

        self.gems = summaryObservableData.property('gems');
        self.xp = summaryObservableData.property('xp');
    };

});

